import React from "react";
import SportRouteStar from "./SportRouteStar";

export default function SportRouteRatingStars(props) {
    return (
        <div className={"c-sportroute__rating-stars"}>
            {props.items?.map((item) => {
                return (
                    <React.Fragment key={item.title}>
                        <div className={"c-sportroute__rating-stars__title"}>{item.title}</div>
                        {item.score >= 0 && item.score <= 5 && (
                            <div className={"c-sportroute__rating-stars__score"}>
                                {[...Array(Math.floor(item.score))].map((e, i) => <SportRouteStar key={i}
                                                                                                  filled={true}/>)}
                                {[...Array(5 - Math.floor(item.score))].map((e, i) => <SportRouteStar key={i}
                                                                                                      filled={false}/>)}
                            </div>
                        )}
                    </React.Fragment>
                )
            })}
        </div>
    )

}
